import { useParams } from "react-router-dom";
import styled from "styled-components";

import OfferingPositionAddForm from "./package-add-form";
import { GoBackButton } from "../../../../components/GoBackButton";
import { theme } from "../../../../helpers/theme";
import PackageAddForm from "./package-add-form";

const StorageAreaPackageAdd = () => {
  const { id } = useParams();

  return (
    <>
      <ButtonWrapper>
        <GoBackButton description={"Powrót"} goToUrl={-1} />
      </ButtonWrapper>
      <StorageAreaPackageAddContainer>
        <PackageAddForm storageAreaId={id} />
      </StorageAreaPackageAddContainer>
    </>
  );
};

export default StorageAreaPackageAdd;

const StorageAreaPackageAddContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-left: 0;
  margin-top: 0px;
  padding-top: 20px;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
    width: 70%;
    margin-top: -50px;
  }
`;
const ButtonWrapper = styled.div`
  width: 70%;
  margin-left: 30px;
  // display: flex;
  // justify-content: flex-start;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
  }
`;
